import Backbone from 'backbone'
import _ from 'lodash'
import template from './checkbox-widget-editor.hbs'
import formWidgetCheckbox from './form-widget-checkbox.hbs'
import formHelper from 'scoreboard/components/form-helper'
import DraggableList from 'draggable-list'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import renderFieldDropdown from 'scoreboard/datasets/render-field-dropdown'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import DataType from 'scoreboard/datasets/model/data-type'
import Dataset from 'scoreboard/datasets/model/dataset'
import {getDialogDatasetOrDataset} from '../edit/pages-edit'
const { TEXT, YES_NO } = DataType

const CheckboxWidgetEditor = Backbone.View.extend({

	tagName: 'form',

	className: 'checkbox-widget-editor',

	events: {
		'click .add-checkbox': 'onClickAddCheckbox',
		'click .delete-checkbox': 'onClickDeleteCheckbox',
		'change select': 'changeField'
	},

	initialize: function(options={}) {
		this.options = options
		this.dataset = getDialogDatasetOrDataset(this.model)
		this.formView = this.options.formView
		this.fields = []
	},

	render: function() {
		this.$el.empty().append(template)
		this.renderCheckboxes()
		return this
	},

	onClickAddCheckbox: function() {
		this.renderCheckbox()
		this.renderDraggableCheckboxes()
		this.formView.change()
	},

	onClickDeleteCheckbox: function(e) {
		let valueEl = this.getCheckboxEl(e)
		valueEl.find('.marked-field').data('view').remove()
		valueEl.remove()
		this.toggleDeleteButton()

		// rerender the checkboxes so the selects are updated with the correct
		// options. (i.e. deleting a checkbox will add its field to all the selects)
		this.renderCheckboxes()
		this.formView.change()
	},

	getCheckboxEl: function(e) {
		return this.$(e.target).closest('.checkbox')
	},

	renderDraggableCheckboxes: function() {
		let list = this.$('ul.checkboxes')
		if (list.find('.checkbox').length > 1) {
			this.draggableCheckboxes = new DraggableList(list[0])
			this.draggableCheckboxes.on('move', this.formView.change.bind(this.formView))
		}
	},

	renderCheckboxes: function() {
		let currentState = this.getData()
		this.$('.checkboxes').empty()

		// If the current data is empty, then this is the initial render since
		// there is always one checkbox by default
		let checkboxes = _.isEmpty(currentState) ?
		  _.get(this.options, 'widget.childWidgets') : currentState

		_.invokeMap(this.fields, 'remove')
		this.fields = []
		this.fieldIds = _.map(checkboxes, checkBox => _.parseInt(checkBox.fieldId))
		_.each(checkboxes, checkbox => {
			this.renderCheckbox(checkbox)
		})
		if (_.isEmpty(checkboxes)) {
			this.renderCheckbox()
		}
		this.renderDraggableCheckboxes()
	},

	changeField: function(e) {
		// By default, make the input's value the same as the field's label
		let fields = this.dataset?.combinedFieldsById
		let newValue = fields[e.target.value].label
		if (!_.isEmpty(newValue)) {
			let inputEl = this.$(e.target)
			  .closest('.checkbox')
			  .find('.value')
			inputEl.val(newValue)
			this.formView.change()
		}
		this.renderCheckboxes()
	},

	renderCheckbox: function(checkbox) {
		this.$('.checkboxes').append(formWidgetCheckbox(checkbox))
		let checkboxEl = this.$('.checkboxes .checkbox').last()
		let checkboxInput = checkboxEl.find('input[type=text]')
		let checkboxSelect = checkboxEl.find('select')

		if (checkbox) {
			checkboxInput.val(checkbox.label)
			checkboxSelect.val(checkbox.fieldId)
		}
		this.fields.push(new MarkedField({
			el: checkboxInput,
			validators: [requiredValidator],
			dataType: this.dataType == TEXT ? null : this.dataType
		}).render())



		// allow fields that are not currently selected in a different checkbox
		// and those that are the current value of this checkbox
		let fieldId = _.isNil(checkbox) ? null : checkbox.fieldId
		let allowedFieldIds = _(this.getYesNoFields())
		  .map(it => it.id)
		  .filter(it => fieldId == it
			|| !_.includes(this.fieldIds, it))
		  .value()
		this.fields.push(renderFieldDropdown({
			el: checkboxSelect,
			dataset: this.dataset,
			required: true,
			allowedFieldIds,
			allowedVisibleLinkedFieldIds: [],
			selectedId: _.isNil(checkbox) ? null : checkbox.fieldId
		}))

		this.toggleDeleteButton()
		formHelper.writeToDom(checkbox, checkboxEl)

		delete this.covertButtonTooltips
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
	},

	getYesNoFields: function() {
		const manuallyAddedFieldId = this.dataset.get('manuallyAddedFieldId')
		const disallowedFieldIds = [manuallyAddedFieldId,
			Dataset.RECORD_EDITED_ID, Dataset.RECORD_IS_EDITABLE_ID]
		return _.filter(this.dataset.combinedFields, field =>
			field.dataType === YES_NO &&
			!_.includes(disallowedFieldIds, field.id))
	},

	toggleDeleteButton: function() {
		let singleCheckbox = this.$('.checkbox').length === 1
		this.$('.delete-checkbox').toggleClass('is-not-displayed', singleCheckbox)
	},

	getData: function() {
		return _.map(this.$('.checkbox'), valueEl => {
			let checkbox = formHelper.readFromDom(valueEl)
			checkbox.id = this.$(valueEl).data('id')
			checkbox.label = this.$(valueEl).find('input[type=text]').val()
			checkbox.fieldId = this.$(valueEl).find('select').val()
			return checkbox
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.fields, this.covertButtonTooltips], 'remove')
	}
})

export default CheckboxWidgetEditor
CheckboxWidgetEditor.__filename__ = 'forms/widgets/checkbox-widget-editor.js'
